import styled, { css } from 'styled-components';

const linkStyles = css`
  color: inherit;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
`;

export const BannerLink = styled.a`
  ${linkStyles};
`;

export const IntercomLink = styled.span`
  ${linkStyles};
`;
